const PHONE_ALIAS_SUFFIX = "@busiconn.com";
const INTERNAL_OAUTH_SUFFIX = "@oauth.busiconn.local";

export function formatLoginIdentifier(value?: string | null) {
  const identifier = value?.trim() ?? "";
  if (!identifier) return "";

  if (identifier.toLowerCase().endsWith(INTERNAL_OAUTH_SUFFIX)) {
    return "Email unavailable";
  }

  if (identifier.toLowerCase().endsWith(PHONE_ALIAS_SUFFIX)) {
    return identifier.slice(0, -PHONE_ALIAS_SUFFIX.length);
  }

  return identifier;
}

export function getLoginIdentifierLabel(value?: string | null) {
  const identifier = formatLoginIdentifier(value);
  return /^\+?\d{10,15}$/.test(identifier) ? "Mobile Number" : "Email";
}
